
import { IndustryProps } from './IndustriesSection';
import { SolutionProps } from './SolutionCard';
import { TestimonialProps } from './TestimonialsSection';

export const industries: IndustryProps[] = [
  { id: 1, name: 'Farms', icon: '\u{1F33E}', description: 'Deter poaching and protect livestock with non-lethal, 24/7 monitoring.' },
  { id: 2, name: 'Estate Residences', icon: '\u{1F3E0}', description: 'Discreet protection that honors your architecture\'s legacy.' },
  { id: 3, name: 'Industrial Sites', icon: '\u{1F3ED}', description: 'Secure perimeters and critical infrastructure from intrusion.' },
  { id: 4, name: 'Municipal Parks', icon: '\u{1F333}', description: 'Monitor public spaces without visible security presence.' },
  { id: 5, name: 'Unmanned Facilities', icon: '\u{1F4E1}', description: 'Remote monitoring for sites without permanent personnel.' },
  { id: 6, name: 'Educational Campuses', icon: '\u{1F3EB}', description: 'Protect students and staff with advanced perimeter security.' }
];

export const solutions: SolutionProps[] = [
  {
    id: 'fibre',
    title: 'Fiber Optic In-Ground',
    description: 'A nearly invisible barrier that analyzes ground vibrations to detect humans, vehicles, or unauthorized movement up to 100km with AI-powered precision.',
    image: '/images/Solutions-Fence-New-Build-3.png',
    link: '/solutions/fibre',
    benefits: [
      'Invisible Barriers: Silent Precision',
      'AI-Powered Accuracy',
      'Enterprise-Ready Scale'
    ]
  },
  {
    id: 'fence',
    title: 'On-Fence Detection',
    description: 'Layers 5000 levels of sensitivity protection to fences, distinguishing between wind and breach attempts, ensuring early intrusion detection.',
    image: '/images/Solutions Fence Overview Section1.png',
    link: '/solutions/fence',
    benefits: [
      'Patented Sensitivity',
      '5000-Levels of Precision',
      'Plug-and-Play'
    ]
  },
  {
    id: 'bespoke',
    title: 'Bespoke Security',
    description: "Adaptive protection for estates, remote assets, and multi-use zones where a template won't do. We audit every access vector, design a layered defence that honours your architecture, and manage the build end-to-end as your single point of contact.",
    image: '/images/Solutions-Bespoke-Case-Studies-Solar-Farm-Remote-1.png',
    link: '/solutions/bespoke',
    benefits: [
      'Tailored Coverage',
      'Discreet Aesthetics',
      'Turn-Key Delivery'
    ]
  },
];

export const testimonials: TestimonialProps[] = [
  {
    quote: "Forti-Fi transformed our security. No more false alarms, no compromises on protection.",
    author: "John B., Winery Estate Manager"
  },
  {
    quote: "Their In-Ground system detected a would-be intruder before they even breached the property line.",
    author: "Sarah T., Rural Business Owner"
  }
];
